<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.companies.title')" header-tag="h3" class="bg-default-card">
                    <div class="" v-if="this.$store.state.userSelectedRole.company_id">
                        <label>{{$t('table.filter_by_status')}}</label>
                        <select class="form-control selectByStatus" v-model="filterByType" @change="onFilterByType">
                            <option value="">{{$t('table.all')}}</option>
                            <option value="main">{{$t('table.main_client')}}</option>
                            <option value="general">{{$t('table.general_client')}}</option>
                            <option value="subcontractor">{{$t('table.subcontractor_client')}}</option>
                            <option value="final">{{$t('table.final_client')}}</option>
                        </select>
                    </div>

                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['company', 'platform'], ['read'])"
                        :importable="true"
                        title=""
                        :rows="getData.rowData"
                        :columns="columnData"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickCertificate="onViewCertificateRow"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                        >
                    </data-table>

                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['company', 'platform'], ['create'])">
                        <i class="fa fa-plus-circle mr-1"></i>{{ $t('general.companies.create_button') }}
                    </b-btn>

                    <span v-if="this.$store.getters.hasPermission(['company', 'platform'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.companies.import_button') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row" v-if="getData.rowData.length > 0">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-graduation-cap text-dark"></i> - {{$t('general.buttons.certificates')}}
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" @hidden="cancelAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['company', 'platform'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.name') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.name">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.no_employees') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.no_employees">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.phone') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="15" class="form-control" v-model="model.phone_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.mobile') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="15" class="form-control" v-model="model.mobile_no">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.annual_revenue') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.annual_revenue">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.year_founded') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==4) return false;" class="form-control" v-model="model.year_founded">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.vat') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.vat">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.address') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.address">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('misc.city') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.city">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('misc.zip_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.zip_code">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.commercial_manager') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedMainCM"
                                :options="currentMainCM"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isMainCMLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onMainCMSearch"
                                @input="updateMainCM"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedMainCM != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedMainCM"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.project_manager') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedMainPM"
                                :options="currentMainPM"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isMainPMLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onMainPMSearch"
                                @input="updateMainPM"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedMainPM != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedMainPM"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.remarks') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remarks"></textarea>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('general.disciplines.title') }}</label>
                        </div>
                        <div class="col-lg-12">
                            <multiselect v-model="selectedDiscipline"
                                :options="currentDiscipline"
                                :multiple="true"
                                :clear-on-select="false"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>

                            <b-btn class="btn btn-default mt-3" @click="onAddDiscipline">
                                <i class="fa fa-plus-circle"></i> {{ $t('general.companies.add_discipline') }}
                            </b-btn>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="!is_platform_admin && hasFilesReadPermission && hasFilesCreatePermission">

            <div class="row mb-3" v-if="!is_platform_admin && hasFilesReadPermission && hasFilesCreatePermission">
                <div class="col-lg-12" v-if="companyLogo == null">
                    <label>{{ $t('table.upload_logo') }}</label>
                </div>

                <div :class="['col-sm-12']" v-if="companyLogo == null">
                    <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                </div>

                <div v-if="companyLogo != null">
                    <div class="col-lg-12">
                        <label>{{ $t('table.company_logo') }}</label>
                    </div>

                    <div class="col-lg-12">
                        <b-img class="cursor-pointer" :src="companyLogo" fluid-grow @click="onDownloadFile"/>
                        <p 
                            v-if="hasFilesDeletePermission"
                            class="float-right p-0 m-0"
                        >
                            <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile"></i>
                        </p>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';
import _ from 'lodash';

export default {
    name: 'companies',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        vueDropzone: vue2Dropzone
    },
    props: {
        filters: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.companies.title'),
                    active: true
                }
            ],
            uploadFieldName: 'excel',
            uploadedFiles: [],
            filterByType: '',
            uploadError: null,
            currentStatus: null,
            tableName: 'company',
            tableNameTranslated: Vue.i18n.translate('general.companies.title_modal'),
            actionTitle: '',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            delete_message: '',
            actionTitleDelete: '',

            file_src: null,
            disciplineIds: [],
            disciplineNames: [],

            selectedMainPM: null,
            currentMainPM: [],
            isMainPMLoading: false,

            selectedMainCM: null,
            currentMainCM: [],
            isMainCMLoading: false,

            selectedDiscipline: null,
            currentDiscipline: [],
            isDisciplineLoading: false,

            companyLogo: null,
            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,

            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: false,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_file'),
                maxFiles: 1,
            },
            getData: {
                rowData: [],
            },
            model: {
                id: null,
                name: null,
                no_employees: null,
                address: null,
                zip_code: null,
                city: null,
                phone_no: null,
                mobile_no: null,
                vat: null,
                disciplines: [],
                remarks: null,
                file: null,
                annual_revenue: null,
                year_founded: null,
                comercial_manager: null,
                project_manager: null,
            },

            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '105px',
                    field: '',
                    showDeleteButton: true,
                    showEditButton: true,
                    showCertificatesButton: true,
                },
                {
                    label: Vue.i18n.translate('table.name'),
                    field: 'name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('misc.city'),
                    field: 'city',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('general.disciplines.title'),
                    width: '250px',
                    field: 'disciplinesName',
                    numeric: false,
                    html: false,
                    sortable: false,
                }
            ]
        }
    },
    computed: {
        is_platform_admin: {
            get: function () {
                if (typeof this.$store.state.userSelectedRole != 'undefined') {
                    if (typeof this.$store.state.userSelectedRole.permissions != 'undefined' && !this.$store.state.userSelectedRole.company_id) {
                        for (var key in this.$store.state.userSelectedRole.permissions) {
                            if (key == 'platform' && this.$store.state.userSelectedRole.permissions[key].update == 1) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            }
        }
    },
    watch: {
        is_company_admin: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    created () {
        if (this.$store.state.userSelectedRole.company_id) {
            this.columnData[0]['showDeleteButton'] = false;
        } else {
            this.columnData[0]['showDeleteButton'] = true;
        }

    },
    mounted () {
        if (this.filters) {
            for (var key in this.filters) {
                switch(key) {
                    case 'type':
                        this.filterByType = this.filters[key]
                        break;
                }
            }
        }
        this.onLoadTable();

        if (this.$store.state.go_back_url == 'companies') {
            this.actionTitle = 'Create ' + this.$options.filters.capitalize(this.tableName);
            this.row = this.$store.state.go_back_data.row;
            this.model = this.$store.state.go_back_data;
            this.$refs.saveModal.show();

            this.$store.state.go_back_data = null;
            this.$store.state.go_back_url = null;
        } else if(this.$store.state.came_from_url == 'disciplines') {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$store.commit('SET_CAMEFROM', null);
            this.model = this.$store.state.go_back_data_list['companies'];
            delete this.$store.state.go_back_data_list['companies'];

            this.row = this.model;

            this.$refs.saveModal.show();
        } else if(this.$store.state.came_from_url == 'projects') {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.$store.commit('SET_CAMEFROM', null);
            this.$refs.saveModal.show();
        }

        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let url = this.tableName + '?search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType +'&filters[type]='+this.filterByType;
            http.route(url).get().then(response => {
                if (response.isError == false) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;

                    var companies = response.data;
                    companies.forEach(function(company,key) {
                        companies[key]['disciplinesName'] = '';
                        if (company.disciplines.length > 0) {
                            let sep = '';
                            company.disciplines.forEach(function(discipline,key2) {
                                companies[key]['disciplinesName'] += sep + discipline['name'];
                                sep = ', ';
                            });
                        }
                    });

                    this.getData.rowData = companies;
                    this.tableLoaded = true;
                } else {
                    let msg = '';
                    Object.keys(response.errorMessage).forEach(key => {
                        msg += Vue.i18n.translate(response.errorMessage[key]) + "\n";
                    });
                    this.errorMsg(msg);
                }
            });
        },
        onFilterByType () {
            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        cancelAction () {
            if(this.$store.state.go_back_url == 'projects') {
                this.$store.commit('SET_CAMEFROM', 'companies');
                this.$router.push({name: 'projects'});
            }
        },
        onAddDiscipline() {
            let data = {
                key: 'companies',
                value: this.model
            }

            this.$store.commit('SET_BACKDATA_LIST', data);
            this.$store.commit('SET_BACKURL_LIST', 'companies');
            this.$store.commit('SET_CAMEFROM', 'companies');

            this.$router.push('disciplines');
        },
        clearSearches () {
            this.currentMainCM     = [];
            this.currentMainPM     = [];
            this.currentDiscipline = [];

            this.selectedDiscipline = null;
            this.selectedMainCM     = null;
            this.selectedMainPM     = null;
            
            this.isMainCMLoading     = false;
            this.isMainPMLoading     = false;
            this.isDisciplineLoading = false;

            this.companyLogo = null;
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();

            this.model.id = null;
            this.model.name = null;
            this.model.no_employees = null;
            this.model.address = null;
            this.model.zip_code = null;
            this.model.city = null;
            this.model.phone_no = null;
            this.model.mobile_no = null;
            this.model.vat = null;
            this.model.disciplines = [];
            this.model.remarks = null;
            this.model.annual_revenue = null;
            this.model.year_founded = null;
            this.model.comercial_manager = null;
            this.model.project_manager = null;
            this.disciplineIds = [];
            this.file_src = null;
           
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated + ': ' + row.name;
            this.row = row;
            this.clearSearches();

            this.selectedMainPM = null;
            this.selectedMainCM = null;
            this.model.id = this.row.id;
            this.model.name = this.row.name;
            this.model.no_employees = this.row.no_employees;
            this.model.address = this.row.address;
            this.model.zip_code = this.row.zip_code;
            this.model.city = this.row.city;
            this.model.phone_no = this.row.phone_no;
            this.model.mobile_no = this.row.mobile_no;
            this.model.vat = this.row.vat;
            this.model.disciplines = this.row.disciplines;
            this.selectedDiscipline = this.row.disciplines;
            this.model.annual_revenue = this.row.annual_revenue;
            this.model.year_founded = this.row.year_founded;
            this.model.comercial_manager = this.row.comercial_manager;
            this.model.project_manager = this.row.project_manager;
            this.model.remarks = this.row.remarks;

            if (this.hasFilesReadPermission && this.row.company_logo != null) {
                this.viewImage(this.row.company_logo.id, this.row.company_logo.file_name);
            }

            if (this.model.comercial_manager != null) {
                this.selectedMainCM = {
                    id: this.row.comercial_manager,
                    fullname: this.row.comercial_manager_name
                };

                if (this.currentMainCM.length == 0 && this.selectedMainCM != null) {
                    this.currentMainCM.push(this.selectedMainCM);
                }
            }

            if (this.model.project_manager != null) {
                this.selectedMainPM = {
                    id: this.row.project_manager,
                    fullname: this.row.project_manager_name
                };

                if (this.currentMainPM.length == 0 && this.selectedMainPM != null) {
                    this.currentMainPM.push(this.selectedMainPM);
                }
            }

            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();
            var vm = this;

            let put_data = {
                name: this.model.name,
                no_employees: this.model.no_employees,
                address: this.model.address,
                zip_code: this.model.zip_code,
                city: this.model.city,
                phone_no: this.model.phone_no,
                mobile_no: this.model.mobile_no,
                vat: this.model.vat,
                disciplines: this.disciplineIds,
                remarks: this.model.remarks,
                comercial_manager: this.model.comercial_manager,
                project_manager: this.model.project_manager,
                annual_revenue: this.model.annual_revenue,
                year_founded: this.model.year_founded,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row && this.row.id) {
                if (this.disciplineIds.length == 0 && this.model.disciplines.length > 0) {
                    this.model.disciplines.forEach(discipline => {
                        this.disciplineIds = discipline.id;
                    });
                }

                put_data['id'] = this.row.id;
                let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.onLoadTable();
                        this.uploadDocuments(this.row.id);
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));

                        if (this.row.id == this.$store.state.userSelectedRole.company_id) {
                            vm.$store.dispatch('getUser');
                        }
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if (response.isError == false) {
                        this.onLoadTable();
                        this.uploadDocuments(response.data.id);
                        this.$refs.saveModal.hide();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        uploadDocuments (id) {
            if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') {
                var file = this.$refs.document.getQueuedFiles();
                for (let order = 0; order < file.length; order++) {
                    var formData = new FormData();
                    formData.append('file', file[order]);
                    formData.append('type', 'company_logo');
                    formData.append('company_logo_id', id);
                    let data = http.route('file').post(
                        formData,
                            {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                            this.onLoadTable();
                        }
                    });
                }
            }
        },
        viewImage(id, name) {
            this.file_id = id;
            http.route('get_content/file/'+id+'/'+name).viewImage({}, '').then(res => {
                if (res) {
                    this.companyLogo = res;
                }
            });
        },
        onDownloadFile () {
            if (this.file_id != null) {
                let data = http.route('file/' + this.file_id).get(
                {
                    export_pdf: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                        let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                    } else {
                        this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                    }
                });
            }
        },
        onDeleteRow (row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile () {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    this.row.file_id = null;
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.$refs.saveModal.hide();
                            this.$store.dispatch('getUser');
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }

            this.$refs.deleteModal.hide();
        },
        onExportButton() {
            http.route(this.tableName).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'companies.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route(this.tableName+'/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
                }
            });
        },
        onMainPMSearch(search) {
            if (search == '') {
                this.currentMainPM = [];
                
                return false;
            }

            this.isMainPMLoading = true;
            this.searchMainPM(search, this);
        },
        searchMainPM: _.debounce((search, vm) => {
            let data = http.route('user/getall?search_select=' + search + '&filters[main_company_id]='+vm.model.id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentMainPM = response.data;
                }
                vm.isMainPMLoading = false;
            });
        }, 500),
        updateMainPM(user) {
            this.model.project_manager = (user != null) ? user.id : null;
        },
        clearSelectedMainPM () {
            this.selectedMainPM        = null;
            this.model.project_manager = null;
        },
        onMainCMSearch(search) {
            if (search == '') {
                this.currentMainCM = [];
                
                return false;
            }

            this.isMainCMLoading = true;
            this.searchMainCM(search, this);
        },
        searchMainCM: _.debounce((search, vm) => {
            let data = http.route('user/getall?search_select=' + search + '&filters[main_company_id]='+vm.model.id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentMainCM = response.data;
                }
                vm.isMainCMLoading = false;
            });
        }, 500),
        updateMainCM(user) {
            this.model.comercial_manager = (user != null) ? user.id : null;
        },
        clearSelectedMainCM () {
            this.selectedMainCM          = null;
            this.model.comercial_manager = null;
        },
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }

            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(disciplines) {
            let disciplineIds = [];

            disciplines.forEach((discipline) => {
                disciplineIds.push(discipline.id)
            });

            this.disciplineIds = disciplineIds;
        },
        onViewCertificateRow(row, index) {
            this.$router.push({name: 'company_certificates', params: {id: row.id}});
        }
    }
}
</script>

<style scoped>
    .custom-file-label {
        z-index: 0;
    }
    select {
        -webkit-appearance:menulist-button;
        -moz-appearance:menulist-button;
    }
</style>

<style>
    .dropzone .dz-preview {
        min-height: 200px;
        min-width:150px;
    }

    .selectByStatus {
        width: 200px !important;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/companies/companies.vue